export const C_GET_ADVERTISER_REQUEST = "C_GET_ADVERTISER_REQUEST"
export const C_GET_ADVERTISER_SUCCESS = "C_GET_ADVERTISER_SUCCESS"
export const C_GET_ADVERTISER_FAILED = "C_GET_ADVERTISER_FAILED"

export const C_GET_S3FILESANDFOLDERS_REQUEST = "C_GET_S3FILESANDFOLDERS_REQUEST"
export const C_GET_S3FILESANDFOLDERS_SUCCESS = "C_GET_S3FILESANDFOLDERS_SUCCESS"
export const C_GET_S3FILESANDFOLDERS_FAILED  = "C_GET_S3FILESANDFOLDERS_FAILED"

export const C_VALIDATE_FOLDER_NAME_REQUEST = "C_VALIDATE_FOLDER_NAME_REQUEST"
export const C_VALIDATE_FOLDER_NAME_SUCCESS = "C_VALIDATE_FOLDER_NAME_SUCCESS"
export const C_VALIDATE_FOLDER_NAME_FAILED  = "C_VALIDATE_FOLDER_NAME_FAILED"

export const C_UPLOAD_FILES_REQUEST = "C_UPLOAD_FILES_REQUEST"
export const C_UPLOAD_FILES_SUCCESS = "C_UPLOAD_FILES_SUCCESS"
export const C_UPLOAD_FILES_FAILED  = "C_UPLOAD_FILES_FAILED"

export const C_UPLOAD_TO_DSP_REQUEST = "C_UPLOAD_TO_DSP_REQUEST"
export const C_UPLOAD_TO_DSP_SUCCESS = "C_UPLOAD_TO_DSP_SUCCESS"
export const C_UPLOAD_TO_DSP_FAILED  = "C_UPLOAD_TO_DSP_FAILED"

export const C_GET_LINEITEMS_REQUEST = "C_GET_LINEITEMS_REQUEST"
export const C_GET_LINEITEMS_SUCCESS = "C_GET_LINEITEMS_SUCCESS"
export const C_GET_LINEITEMS_FAILED = "C_GET_LINEITEMS_FAILED"

export const getAdvertiser = ()=>{
    return{type:C_GET_ADVERTISER_REQUEST}
}

export const getS3FilesAndFoldersAction = (folderName:any)=>{
    return {type:C_GET_S3FILESANDFOLDERS_REQUEST,payload:folderName}
}

export const validateFolderNameAction = (folderName:string)=>{
    return{type:C_VALIDATE_FOLDER_NAME_REQUEST,payload:folderName}
}

export const uploadToS3 = (data: any,folder:any)=>{
    return{type:C_UPLOAD_FILES_REQUEST,payload:{data,folder}}
}

export const uploadToDSP = (files:any[],url:string,folder:string,campaign:string,campaignName:string)=>{
    return{type:C_UPLOAD_TO_DSP_REQUEST,payload:{files,url,folder,campaign,campaignName}}
}

export const getLineItems = ()=>{
    return{type:C_GET_LINEITEMS_REQUEST}
}